module.exports = __webpack_public_path__ + "static/media/unloaded_inactive.60f45026.svg";